import React, { useState } from 'react'

const AuthForm = ({ onAuthenticate }) => {
  const [password, setPassword] = useState('')
  const [error, setError] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    // Use the secure password - in production this comes from env var
    const validPassword = import.meta.env.VITE_AUTH_PASSWORD || 'axaMIEwiP0hToFAG6a9lBnHaMJKKH16WbjcABZ7aGmQ='
    
    if (password === validPassword) {
      onAuthenticate()
    } else {
      setError(true)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full">
        <div className="bg-white shadow-lg rounded-lg px-8 py-10">
          <h2 className="text-2xl font-bold text-center text-gray-900 mb-8">
            Proposal Generator
          </h2>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                Password
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value)
                  setError(false)
                }}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter password"
                required
              />
              {error && (
                <p className="mt-2 text-sm text-red-600">
                  Invalid password. Please try again.
                </p>
              )}
            </div>
            <button
              type="submit"
              className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Sign In
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default AuthForm